import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {StudentResponse, StudentsClient, StudentUpdateRequest} from '../../../generated-client/generated-api-client';
import {FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {
  isFormModifiedDataService,
  SimpleNavigationPathDataService,
} from '../../../services/data-services/navigation-data-services';
import {SimpleModalService} from 'ngx-simple-modal';
import {
  ExamDateShiftConfirmModalComponent
} from 'src/app/components/modals/exam-date-shift-confirm-modal/exam-date-shift-confirm-modal.component';
import {DateTime} from 'luxon';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-student-edit',
  templateUrl: './student-edit.component.html',
  styleUrls: ['./student-edit.component.sass'],
})
export class StudentEditComponent implements OnInit {
  examReportId!: string;
  studentId!: string;
  response!: Observable<StudentResponse>;

  constructor(
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private client: StudentsClient,
    private _navigationService: SimpleNavigationPathDataService,
    private _modalService: SimpleModalService,
    private errorProcessorService: ErrorProcessorService,
    private _toastr: ToastrService,
    private _isFormModifiedDataService: isFormModifiedDataService
  ) {
    route.paramMap.subscribe(next => {
      this.examReportId = next.get('examReportId') ?? '';
    });
    route.paramMap.subscribe(next => {
      this.studentId = next.get('studentId') ?? '';
    });
    this.titleService.setTitle('Vizsgázó létrehozása');
  }

  ngOnInit(): void {
    this.response = this.client.get(this.studentId);
  }

  onSubmit(form: FormGroup): void {
    const request: StudentUpdateRequest = {
      id: this.studentId,
      registrationNumber: form.get('registrationNumber')?.value === '' ? null : form.get('registrationNumber')?.value,
      title: form.get('title')?.value === '' ? null : form.get('title')?.value,
      surname: form.get('surname')?.value === '' ? null : form.get('surname')?.value,
      forename1: form.get('forename')?.value === '' ? null : form.get('forename')?.value,
      forename2: form.get('forename2')?.value === '' ? null : form.get('forename2')?.value,
      citizenship: form.get('citizenship')?.value === '' ? null : form.get('citizenship')?.value,
      mothersName: form.get('mothersName')?.value === '' ? null : form.get('mothersName')?.value,
      birthPlace: form.get('birthplace')?.value === '' ? null : form.get('birthplace')?.value,
      birthDate: form.get('birthdate')?.value === '' ? null : form.get('birthdate')?.value,
      birthName: form.get('birthName')?.value === '' ? null : form.get('birthName')?.value,
      email: form.get('email')?.value === '' ? null : form.get('email')?.value,
      language: form.get('language')?.value === '' ? null : form.get('language')?.value,
      computerNumber: form.get('computerNumber')?.value === '' ? null : form.get('computerNumber')?.value,
      examStartedAtUtc: form.get('examStartedAtUtc')?.value === '' ? null : form.get('examStartedAtUtc')?.value,
      examDateShift: false,
    };
    if (form.get('examStartedAtUtc')?.dirty) {
      this._modalService
        .addModal(ExamDateShiftConfirmModalComponent, {
          title: 'Szeretné a vizsgázóhoz tartozó összes vizsgatárgy kezdési időpontját a beállított időponthoz képest eltolni?',
          studentId: this.studentId,
          date: DateTime.fromISO(form.get('examStartedAtUtc')?.value),
        })
        .subscribe(next => {
          if (next === undefined) {
            return;
          }

          if (next) {
            request.examDateShift = true;
          }

          this.sendRequest(request);
        });
    } else {
      this.sendRequest(request);
    }
  }

  private sendRequest(request: StudentUpdateRequest): void {
    this.client.edit(request).subscribe(
      next => {
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate([`/exam-reports/${this.examReportId}/students/${next.entityId}`]);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
